import React from "react";
import cx from "classnames";

import NovaConversationTitle from "./NovaConversationTitle";
import useNovaAiModalHeader from "./hooks/useNovaAiModalHeader";

import { ReactComponent as SparklesSVG } from "resources/icons/sparkles.svg";
import { ReactComponent as Chats } from "resources/icons/Chats.svg";
import { ReactComponent as ArrowsOutCardinal } from "resources/icons/ArrowsOutCardinal.svg";
import { ReactComponent as Clockicon } from "resources/icons/ClockCounterClockwise.svg";
import { ReactComponent as Closebutton } from "resources/icons/X.svg";
import { ReactComponent as NewConversationButton } from "resources/icons/newconversation.svg";

const CreateWithNovaAiModalHeader = (props) => {
  const { setDisabled, handleShowHistory, disabled } = props;
  const superAdminToken = window.localStorage.getItem("super_admin_token");
  const impersonatorAuthToken = window.localStorage.getItem(
    "impersonator_auth_token"
  );
  const hideSupportInSettings = superAdminToken || impersonatorAuthToken;
  const { novaHeaderProps } = useNovaAiModalHeader(props);

  const { setHovered, openChatWoot, createNewConvo, handleCloseIconClick } =
    novaHeaderProps;
  return (
    <div className="flex align-center justify-between">
      <div className="flex align-center display-block w-40">
        <div>
          <SparklesSVG className="mr-4 mb--4 display-inline" />
          <div className="pl-8 fs-regular fw-600 color-grey display-inline">
            Nova AI
          </div>
        </div>
        <div
          className={cx("px-8 py-2 mt-3 fs-medium fw-500 conversation-title", {
            editing: novaHeaderProps.isEditing,
          })}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <NovaConversationTitle {...novaHeaderProps} />
        </div>
      </div>

      <div className="flex align-end mb-30 chat-with-nova-ai-header-options">
        {!hideSupportInSettings && (
          <div
            className="fs-small fw-600 nova-support cursor-pointer"
            onClick={() => openChatWoot()}
          >
            <Chats className="mr-4" />
            Support
          </div>
        )}

        <NewConversationButton
          className="cursor-pointer new-conversation-button"
          onClick={createNewConvo}
          title={"Create new conversation"}
        />

        <Clockicon
          className="cursor-pointer nova-history-icon"
          onClick={handleShowHistory}
          title={"Show History"}
        />
        <ArrowsOutCardinal
          className={`draggable-handle ${
            disabled ? "text-gray-400" : "text-primary"
          } cursor-move`}
          onClick={() => setDisabled(false)}
          title={"Click & drag to move"}
        />
        <Closebutton
          className="cursor-pointer ai-modal-close-svg"
          onClick={handleCloseIconClick}
        />
      </div>
    </div>
  );
};

export default CreateWithNovaAiModalHeader;
